module.exports = __webpack_public_path__ + "static/media/icon-check-completed.41002741.svg";